import React from 'react';

export function ProjectProgressHeader() {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 bg-white p-3 rounded-md border border-slate-100 ">
      <div className="flex flex-wrap items-center gap-3">
        {/* Chế độ xem */}
        <div className="relative min-w-[180px]">
          <select className="appearance-none w-full h-9 pl-3 pr-8 rounded-md border border-slate-200 bg-slate-50 text-xs lg:text-sm text-slate-600 focus:outline-none focus:border-emerald-500 transition-all cursor-pointer font-normal">
            <option>Chế độ xem: Tiến độ tổng thể</option>
            <option>Tiến độ theo hạng mục</option>
            <option>Tiến độ theo nhân sự</option>
          </select>
          <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
        </div>

        {/* Khoảng thời gian */}
        <div className="flex items-center gap-2 h-9 px-3 rounded-md border border-slate-200 bg-slate-50 text-xs lg:text-sm text-slate-600 cursor-pointer hover:bg-white transition-all font-normal">
          <span>01/04/2024 - 30/09/2024</span>
          <i className="ri-calendar-line text-slate-400" />
        </div>

        {/* Nhóm theo */}
        <div className="relative min-w-[150px]">
          <select className="appearance-none w-full h-9 pl-3 pr-8 rounded-md border border-slate-200 bg-slate-50 text-xs lg:text-sm text-slate-600 focus:outline-none focus:border-emerald-500 transition-all cursor-pointer font-normal">
            <option>Nhóm theo: Hạng mục</option>
            <option>Nhóm theo: Trạng thái</option>
          </select>
          <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
        </div>
      </div>

      <div className="flex items-center gap-4">
        <span className="text-xs text-slate-400 font-normal">Ngày cập nhật: 15/05/2024 09:30</span>
        <button className="h-9 px-4 rounded-md border border-slate-200 bg-white flex items-center gap-2 text-xs lg:text-sm font-normal text-slate-600 hover:bg-slate-50 transition-all">
          <i className="ri-refresh-line" />
          <span>Làm mới</span>
        </button>
      </div>
    </div>
  );
}
